<script lang="ts">
  import OtherOptionModal from './OtherOptionModal.svelte';
  import ChangeMailPasswordDetail from './ChangeMailPasswordDetail.svelte';
  import { format } from 'date-fns';
  import { ja } from 'date-fns/locale';
  import { push } from 'svelte-spa-router';
  import { loginUser } from '../../../../components/auth/LoginUser';
  import type { BundleOptionHikari01InheritedResult as FetchResult } from '../../../../repositories/bundleoptionhikari01inherited';
  import RepositoryFactory, { BUNDLE_OPTION_HIKARI01_INHERITED } from '../../../../repositories/RepositoryFactory';
  import type { IQitMailItem } from './types';

  export let props: FetchResult;

  let pageStatus: 'TOP' | 'BACK_MAIN_LIST' | 'CONFIRM' | 'COMPLETE' | 'CHANGE_MAIL_PASSWORD' = 'TOP';

  // 画面表示用に見やすい形に置き換え
  let qitMailItem: IQitMailItem = {
    mailAddress: props.inheritedMailAddress,
    mailPassword: props.inheritedMailPassword,
    contractStartDate: props.contractStartDate,
    contractEndDate: props.contractEndDate ?? '-',
    transferSettingItem: {
      setting: props.qitMailTransferSettingFlg === 1 ? 'あり' : 'なし',
      mailAddress: props.qitMailTransferAddress ?? '-'
    },
    pop: props.mailCommonPopServer ?? '-',
    smtp: props.mailCommonSmtpServer ?? '-',
    imap: props.mailCommonImapServer ?? '-'
  };

  const handleTransitionConfirm = (): void => {
    qitMailItem.contractEndDate = format(new Date(), 'yyyy/MM/dd', {
      locale: ja
    });
    pageStatus = 'CONFIRM';
  };

  const handleTransitionComplete = (): void => {
    const repository = RepositoryFactory[BUNDLE_OPTION_HIKARI01_INHERITED];
    repository
      .terminate({
        bundleOptionHikari01InheritedId: props.bundleOptionHikari01InheritedId
      })
      .then((res) => {
        pageStatus = 'COMPLETE';
      })
      .catch((error) => {
        if (error.response.status === 403) {
          alert('セッションが切れました。再度ログインしてください。');
          loginUser.logout();
          push('/login');
        } else {
          alert('エラーが発生しました。');
        }
      });
  };

  const handleTransitionChangeMailPassword = (): void => {
    pageStatus = 'CHANGE_MAIL_PASSWORD';
  };

  const handleTransitionBackTop = (): void => {
    pageStatus = 'TOP';
  };
  const handleTransitionBackMainList = (): void => {
    pageStatus = 'BACK_MAIN_LIST';
  };
</script>

{#if pageStatus === 'TOP'}<!-- トップ画面 -->
  <div class="h-auto p-6 bg-white m-auto max-w-4xl">
    <div class="mb-6">
      <div class="container flex justify-between">
        <h2 class="text-xl font-bold text-gray-700">旧Qitメール</h2>
      </div>
    </div>
    <div class="shadow rounded bg-white border-t-2 border-green-400">
      <div class="flex flex-col justify-items-center items-center mt-5">
        <div class="w-11/12 content-center p-4">
          <div class="text-base font-semibold">
            <div>旧Qitメールは1アドレス分は無料です</div>
          </div>

          <!-- メールアドレス -->
          <div class="inline-grid grid-cols-3 items-center min-w-full p-2">
            <div class="grid-1 justify-self-start w-full">
              <span class="label-title">メールアドレス</span>
            </div>
            <div class="grid-1 justify-self-start w-full">
              <span class="label-value">{qitMailItem.mailAddress}</span>
            </div>
            <div class="grid-1" />
          </div>
          <!-- メールパスワード -->
          <div class="inline-grid grid-cols-3 items-center min-w-full p-2">
            <div class="grid-1 justify-self-start w-full">
              <span class="label-title">メールパスワード</span>
            </div>
            <div class="grid-1 justify-self-start w-full">
              <span class="label-value">{qitMailItem.mailPassword}</span>
            </div>
            <div class="grid-1 justify-self-center">
              <button on:click={handleTransitionChangeMailPassword} class="button-change-password">
                パスワード変更
              </button>
            </div>
          </div>
          <!-- 契約開始日 -->
          <div class="inline-grid grid-cols-3 items-center min-w-full p-2">
            <div class="grid-1 justify-self-start w-full">
              <span class="label-title">契約開始日</span>
            </div>
            <div class="grid-1 justify-self-start w-full">
              <span class="label-value">{qitMailItem.contractStartDate}</span>
            </div>
            <div class="grid-1" />
          </div>
          <!-- 契約終了日 -->
          <div class="inline-grid grid-cols-3 items-center min-w-full p-2">
            <div class="grid-1 justify-self-start w-full">
              <span class="label-value">契約終了日</span>
            </div>
            <div class="grid-1 justify-self-start w-full">
              <span class="label-title">{qitMailItem.contractEndDate}</span>
            </div>
            <div class="grid-1" />
          </div>
          <!-- メール転送設定 -->
          <div class="inline-grid grid-cols-3 items-center min-w-full p-2">
            <div class="grid-1 justify-self-start w-full">
              <span class="label-title">メール転送設定</span>
            </div>
            <div class="grid-1 justify-self-start w-full">
              <p class="label-value">
                {`${qitMailItem.transferSettingItem.setting}(${qitMailItem.transferSettingItem.mailAddress})`}
              </p>
            </div>
            <div class="grid-1 justify-self-start w-full">
              <p class="label-value">※転送設定利用料330円</p>
            </div>
          </div>
          <!-- POPサーバ -->
          <div class="inline-grid grid-cols-3 items-center min-w-full p-2">
            <div class="grid-1 justify-self-start w-full">
              <span class="label-title">POPサーバ</span>
            </div>
            <div class="grid-1 justify-self-start w-full">
              <span class="label-value">{qitMailItem.pop}</span>
            </div>
            <div class="grid-1" />
          </div>
          <!-- SMTPサーバ -->
          <div class="inline-grid grid-cols-3 items-center min-w-full p-2">
            <div class="grid-1 justify-self-start w-full">
              <span class="label-title">SMTPサーバ</span>
            </div>
            <div class="grid-1 justify-self-start w-full">
              <span class="label-value">{qitMailItem.smtp}</span>
            </div>
            <div class="grid-1" />
          </div>
          <!-- IMAPサーバ -->
          <div class="inline-grid grid-cols-3 items-center min-w-full p-2">
            <div class="grid-1 justify-self-start w-full">
              <span class="label-title">IMAPサーバ</span>
            </div>
            <div class="grid-1 justify-self-start w-full">
              <span class="label-value">{qitMailItem.imap}</span>
            </div>
            <div class="grid-1" />
          </div>
        </div>
      </div>

      <div class="flex flex-col justify-items-center items-center">
        <div class="flex-1 m-5 flex flex-col md:flex-row justify-items-center items-center">
          <button class="button-secondary md:ml-5 mb-5 w-40" on:click={handleTransitionBackMainList}> 戻る </button>
          <button class="button-primary md:ml-5 mb-5 w-40" on:click={handleTransitionConfirm}> 解約する </button>
        </div>
      </div>
    </div>
  </div>
{:else if pageStatus === 'CONFIRM'}<!-- 旧qitメール解約 確認 -->
  <div class="h-auto p-6 bg-white m-auto max-w-4xl">
    <div class="mb-6">
      <div class="container flex justify-between">
        <h2 class="text-xl font-bold text-gray-700">旧Qitメール</h2>
      </div>
    </div>
    <div class="shadow rounded bg-white border-t-2 border-green-400">
      <div class="m-10">
        <div class="inline-flex justify-items-center items-center min-w-full">
          <div class="mb:font-sm w-full">
            <ul class="list-none">
              <li>
                <p>以下オプションを解約する場合、解約するボタンを押下ください。</p>
              </li>
              <li>
                <p>解約ボタン押下後は、サービスの利用ができなくなります。</p>
              </li>
              <li>
                <p>解約の取り消しはできませんのでご注意ください。</p>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="flex flex-col justify-items-center items-center mt-6">
        <div class="w-full content-center p-4">
          <!-- メールアドレス -->
          <div class="inline-grid grid-cols-3 items-center min-w-full p-2">
            <div class="grid-1 justify-self-start w-full">
              <span class="label-title">メールアドレス</span>
            </div>
            <div class="grid-1 col-span-2 justify-self-start w-full">
              <span class="label-value">{qitMailItem.mailAddress}</span>
            </div>
            <div class="grid-1" />
          </div>
          <!-- 契約終了日 -->
          <div class="inline-grid grid-cols-3 items-center min-w-full p-2">
            <div class="grid-1 justify-self-start w-full">
              <span class="label-title">契約終了日</span>
            </div>
            <div class="grid-1 justify-self-start w-full">
              <span class="label-value">{qitMailItem.contractEndDate}</span>
            </div>
            <div class="grid-1" />
          </div>
        </div>
      </div>

      <div class="flex flex-col justify-items-center items-center">
        <div class="flex-1 m-5 flex flex-col md:flex-row justify-items-center items-center">
          <button class="button-secondary md:ml-5 mb-5 w-40" on:click={handleTransitionBackTop}> 戻る </button>
          <button class="button-primary md:ml-5 mb-5 w-40" on:click|once={handleTransitionComplete}> 解約する </button>
        </div>
      </div>
    </div>
  </div>
{:else if pageStatus === 'COMPLETE'}<!-- 旧qitメール解約 完了 -->
  <div class="h-auto p-6 bg-white m-auto max-w-4xl">
    <div class="mb-6">
      <div class="container flex justify-between">
        <h2 class="text-xl font-bold text-gray-700">旧Qitメール</h2>
      </div>
    </div>
    <div class="shadow rounded bg-white border-t-2 border-green-400">
      <div class="m-10">
        <div class="inline-flex justify-items-center items-center min-w-full">
          <div class="mb:font-sm w-full">
            <ul class="list-none">
              <li>
                <p>以下オプションを解約しました</p>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="flex flex-col justify-items-center items-center mt-4">
        <div class="w-11/12 content-center p-4 mb-20">
          <!-- メールアドレス -->
          <div class="inline-grid grid-cols-3 items-center min-w-full p-2">
            <div class="grid-1 justify-self-start w-full">
              <span class="label-title">メールアドレス</span>
            </div>
            <div class="grid-1 col-span-2 justify-self-start w-full">
              <span class="label-value">{qitMailItem.mailAddress}</span>
            </div>
            <div class="grid-1" />
          </div>
          <!-- 契約終了日 -->
          <div class="inline-grid grid-cols-3 items-center min-w-full p-2">
            <div class="grid-1 justify-self-start w-full">
              <span class="label-title">契約終了日</span>
            </div>
            <div class="grid-1 justify-self-start w-full">
              <span class="label-value">{qitMailItem.contractEndDate}</span>
            </div>
            <div class="grid-1" />
          </div>
        </div>
      </div>
    </div>
  </div>
{:else if pageStatus === 'CHANGE_MAIL_PASSWORD'}<!-- メールパスワード 変更 -->
  <ChangeMailPasswordDetail {props} transitionSource={'QIT'} />
{:else if pageStatus === 'BACK_MAIN_LIST'}<!-- 戻る 承継オプションリスト画面 -->
  <OtherOptionModal />
{/if}

<style lang="postcss">
  p:not([class]) {
    @apply tracking-normal mb-1;
  }
  .label-title {
    @apply text-sm font-medium text-gray-700;
  }
  .label-value {
    @apply text-sm font-medium text-gray-900 break-all;
  }

  .button-primary {
    @apply bg-green-400 rounded hover:bg-green-500 text-sm font-semibold text-white focus:outline-none px-10 py-2;
  }
  .button-change-password {
    @apply bg-green-400 rounded hover:bg-green-500 text-sm font-semibold text-white focus:outline-none px-6 py-2;
  }

  .button-secondary {
    @apply bg-gray-300 rounded hover:bg-gray-400 text-gray-500 text-sm font-semibold focus:outline-none px-10 py-2;
  }
</style>
